// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outputTextarea[data-v-6bff6c4b] {\n  min-width: 350px;\n}\n.configTable td[data-v-6bff6c4b] {\n  padding: 2px 0;\n}\n.myBox[data-v-6bff6c4b] {\n  padding: 30px;\n  margin: 20px;\n  border: 2px solid black;\n  border-radius: 15px;\n  background-color: white;\n  min-width: 600px;\n  max-width: 1000px;\n  overflow-x: hidden;\n}", ""]);
// Exports
module.exports = exports;
